import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import * as React from "react";

type Props = {
    ariaLabel: string;
    className?: string;
    copiedTitle?: string;
    iconSize?: number;
    text: string;
    title: string;
};

const CopyToClipboardButton: React.FC<Props> = ({
    ariaLabel,
    className,
    copiedTitle = "Copied!",
    iconSize = 16,
    text,
    title,
}) => {
    const [copied, setCopied] = React.useState(false);

    const handleCopy = async () => {
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed";
                textArea.style.opacity = "0";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
            }

            setCopied(true);
            window.setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error("Failed to copy text to clipboard.", error);
        }
    };

    const buttonClassName = className
        ? `copy-to-clipboard-button ${className}`
        : "copy-to-clipboard-button";

    return (
        <Tooltip title={copied ? copiedTitle : title}>
            <Button
                type="link"
                size="small"
                onClick={handleCopy}
                aria-label={ariaLabel}
                className={buttonClassName}
            >
                {copied ? (
                    <CheckOutlined
                        className="copy-to-clipboard-button__icon is-copied"
                        style={{ fontSize: iconSize }}
                    />
                ) : (
                    <CopyOutlined
                        className="copy-to-clipboard-button__icon"
                        style={{ fontSize: iconSize }}
                    />
                )}
            </Button>
        </Tooltip>
    );
};

export default CopyToClipboardButton;
